export const CURATION_NAME = 'curation';

const prefix = 'CURATION';
export const CURATION_ACTIONS = {
  'INIT': prefix + '_INIT',
  'SET_WORKLIST': prefix + '_SET_WORKLIST',
  'ADD_WORKLIST_ITEM': prefix + '_ADD_WORKLIST_ITEM',
  'SET_CURATION_DEFINITION': prefix + '_SET_CURATION_DEFINITION',
  'SET_CURATION_ACTIVE_KB': prefix + '_SET_CURATION_ACTIVE_KB',
  'SET_CURATION_GRANTED_KB': prefix + 'SET_CURATION_GRANTED_KB',
  "SET_PREVIEW_PATIENT": prefix + "_SET_PREVIEW_PATIENT",
  "SET_PREVIEW_CONFIGURATIONS": prefix + "_SET_PREVIEW_CONFIGURATIONS",
  "SET_PREVIEW_MODE": prefix + "_SET_PREVIEW_MODE",
  "SET_CURATION_VALUESETS": prefix + '_SET_CURATION_VALUESETS',
  'SET_GRANTED_ACTIONS_TABLE': prefix + '_SET_GRANTED_ACTIONS_TABLE',
  'SET_MULTIPLE_KB_DATA': prefix + 'SET_MULTIPLE_KB_DATA'
};
